/* =============================================================================
 * Runtime configuration — set via .env (see .env.example).
 *
 * The backend runs as two separate services (README: cmd/server on :8080,
 * cmd/admin on :8081), so there are two base URLs. The public site only ever
 * talks to the candidate API; the admin portal only to the admin API.
 * ========================================================================== */

const env = import.meta.env;

// The APIs have no CORS policy, so each site calls /api on its OWN domain and the
// web server (Caddy in production, Vite's proxy in dev) forwards to the Go service.
export const CANDIDATE_API_BASE: string = env.VITE_CANDIDATE_API_BASE || '/api';
export const ADMIN_API_BASE: string = env.VITE_ADMIN_API_BASE || '/api';

/**
 * Cloudflare Turnstile site key (public — safe to ship). Required for registration.
 * In `deno task dev` Cloudflare's always-pass TEST key is used when unset. A
 * production build without a real key shows an error instead of the widget —
 * see README → Turnstile.
 */
export const TURNSTILE_SITE_KEY: string = env.VITE_TURNSTILE_SITE_KEY ||
  (env.DEV ? '1x00000000000000000000AA' : '');

/** true → every API call is answered by the in-browser mock (src/shared/api/mock). */
export const USE_MOCK: boolean = env.VITE_USE_MOCK === 'true';

/** 'hash' for static hosts without SPA fallback (and for the preview build). */
export const ROUTER_MODE: 'browser' | 'hash' = env.VITE_ROUTER === 'hash' ? 'hash' : 'browser';

/** Link back to the parent WordPress site. */
export const MAIN_SITE_URL = 'https://chatrapatisevapratishthan.org/';
